export const MENU = 'MENU';
